/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ChangedIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="-1 -1 66 66"
    onClick={props.onClick}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
      <polygon points="27.5404444 42.2257778 14.3404444 47.8844444 19.9991111 34.6817778 43.5697778 11.1111111 51.1111111 18.6551111" />
      <path d="M46.2151111,23.5511111 L38.6737778,16.0071111" />
      <path d="M27.5404444,42.2257778 L19.9991111,34.6817778" />
      <circle cx="31.1111111" cy="31.1111111" r="30.6666667" />
    </g>
  </svg>
);

export default ChangedIcon;
